module.exports = __webpack_public_path__ + "img/peixes.5659ef77.jpg";